import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { fromEvent, merge } from 'rxjs';
import { AtomDataSource } from 'src/app/services/atomTable.datasource';
import { SharedService } from 'src/app/services/sharedService';
import { StreetDialogComponent } from './dialog/street-dialog/street-dialog.component';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { LocationService } from 'src/app/services/region.service';
 

@Component({
  selector: 'atom-street',
  templateUrl: './street.component.html',
  styleUrls: ['./street.component.css']
})
export class StreetComponent implements OnInit, OnDestroy {
  subscriptionUpdateStreet: any;
  subscriptionDeleteStreet: any;

  displayedColumns: string[] = ['name', 'action'];
  dataSource: AtomDataSource;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('input_search', { static: false }) input: ElementRef;

  constructor(private locationService: LocationService, public dialog: MatDialog, public sharedService: SharedService) {
    this.subscriptionUpdateStreet = this.sharedService.updateStreetEmmitter.subscribe(val => {
      if (val) {
        this.locationService.updateResource('dictionary/street', val).subscribe(res => {
          this.loadStreetTable();
        })
      }
    })
    this.subscriptionDeleteStreet = this.sharedService.deleteStreetEmmitter.subscribe(val => {
      if (val) {
        this.locationService.deleteResource('dictionary/street', val).subscribe(res => {
          this.loadStreetTable();
        })
      }
    })
 
  }

  ngOnInit() {
    this.dataSource = new AtomDataSource(this.locationService)
    // this.dataSource.loadVisits( '', 'asc', 'name', 0, this.paginator.pageSize);
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.dataSource.loadData('dictionary/street', '', 'asc', 'name', 0, this.paginator.pageSize, {});

    }, 0)

    this.sort.sortChange.subscribe(() => {});

    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadStreetTable();
        })
      )
      .subscribe();

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadStreetTable())
      )
      .subscribe();

  }

  loadStreetTable() {
    this.dataSource.loadData('dictionary/street',
      this.input.nativeElement.value,
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, {});
  }

  openStreetDialog(street): void {
    const dialogRef = this.dialog.open(StreetDialogComponent, {
      width: '550px', panelClass: 'custom-dialog-container',
      data: street
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  openDeleteDialog(street): void {
    street['class'] = 'STREET';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '600px', panelClass: 'custom-dialog-container',
      data: {obj:street, text: 'DIALOG.DELETE_CURRENT_STREET', action: 'DELETE' }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  ngOnDestroy() {
    if (this.subscriptionUpdateStreet) this.subscriptionUpdateStreet.unsubscribe();
    if (this.subscriptionDeleteStreet) this.subscriptionDeleteStreet.unsubscribe();
  }

}
